module.exports = "/*footer style starts*/\n.main-footer{\n    background-color: #003c51;    \n}\n.main-footer p{color: white;text-align:center;}\n/*footer style ends*/"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cqm-ns/cqm-ns-footer/cqm-ns-footer.component.css
// module id = ./src/app/modules/cqm-ns/cqm-ns-footer/cqm-ns-footer.component.css
// module chunks = main